import {
  createContext,
  type PropsWithChildren,
  useContext,
  useEffect,
} from 'react';

import { brandingConfig, type ThemeConfig } from '@/config/branding';

const ThemeContext = createContext<ThemeConfig>(brandingConfig);

export function ThemeProvider({ children }: PropsWithChildren) {
  useEffect(() => {
    const root = document.documentElement;

    Object.entries(brandingConfig.tokens).forEach(([token, value]) => {
      root.style.setProperty(token, value);
    });

    document.title = `${brandingConfig.brandName} Admin Portal`;

    document.head
      .querySelectorAll('link[data-whitelabel-favicon="true"]')
      .forEach((element) => element.remove());

    brandingConfig.favicons.forEach((favicon) => {
      const link = document.createElement('link');
      link.setAttribute('data-whitelabel-favicon', 'true');
      link.rel = favicon.rel;
      link.href = favicon.href;

      if (favicon.type) {
        link.type = favicon.type;
      }

      if (favicon.sizes) {
        link.sizes = favicon.sizes;
      }

      document.head.appendChild(link);
    });
  }, []);

  return (
    <ThemeContext.Provider value={brandingConfig}>
      {children}
    </ThemeContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useTheme() {
  return useContext(ThemeContext);
}
